import { useEffect, useState } from "react";
import TemplatesService from "../../Services/TemplatesService";
import { useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import TemplateStepOffcanvas from "./TemplateStepOffcanvas";
import ApplyTemplateModal from "../../Modals/ApplyTemplateModal";

function TemplateDetail() {

    const [template, setTemplate] = useState({
        name: 'loading...',
        steps: []
    });

    const [show, setShow] = useState(false);
    const [selectedStep, setSelectedStep] = useState({});
    const [showApplyModal, setShowApplyModal] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        getTemplateDetail();
    }, []);

    async function getTemplateDetail() {
        const _template = await TemplatesService.getTemplateById(id);
        setTemplate(_template);
    }

    function onClose() {
        setShow(false);
    }

    function onStepClick(step) {
        setSelectedStep(step);
        setShow(true);
    }

    function onApplyTemplateClick() {
        setShowApplyModal(true);
    }

    function onCloseApplyModal() {
        setShowApplyModal(false);
    }

    function renderSteps() {
        return template.steps.map((step, index) => {
            // Obtener información de variaciones
            const variationsCount = step.variations ? step.variations.length : 1;
            const variationsText = variationsCount === 1 ? '1 variation' : `${variationsCount} variations`;

            // Obtener preview de la primera variación para mostrar
            const firstVariation = step.variations && step.variations.length > 0
                ? step.variations[0]
                : { body: step.body || "", textBody: step.textBody || "" };

            const previewText = firstVariation.textBody || step.textBody || "No content";

            return (
                <div key={index} className="card card-shadow mb-4">
                    <div className="card-header bg-white d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <span className="badge text-bg-light btn-circle me-3">
                                <i className="far fa-envelope text-primary"></i>
                            </span>
                            <span className="bold">
                                Day {step.daysWait + 1}: Automatic email
                            </span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="badge bg-info me-2">
                                <i className="fas fa-layer-group me-1"></i>
                                {variationsText}
                            </span>
                        </div>
                    </div>
                    <div className="card-body sequence-detail-item">
                        <div onClick={() => onStepClick(step)} className="d-flex align-items-center pointer">
                            <span className="mx-2">A</span>
                            <span className="mx-2 bold">
                                {step.replyInThread ? 'Same thread' : 'New thread'}
                            </span>

                            <div className="mx-2 flex-grow-1">
                                <div className="fw-bold">{step.subject}</div>
                                <div className="text-muted">{previewText}</div>

                                {/* Mostrar todas las variaciones si hay más de una */}
                                {step.variations && step.variations.length > 1 && (
                                    <div className="mt-2">
                                        <small className="text-muted">
                                            <strong>Variations:</strong> {step.variations.map((v, i) => v.name).join(', ')}
                                        </small>
                                    </div>
                                )}
                            </div>

                            <div className="ms-auto">
                                <i className="fas fa-edit text-primary"></i>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <div>
            <TemplateStepOffcanvas
                show={show}
                onClose={onClose}
                onRefresh={() => {
                    getTemplateDetail();
                    setShow(false);
                }}
                selectedStep={selectedStep}
                setSelectedStep={setSelectedStep}
            />

            <ApplyTemplateModal
                show={showApplyModal}
                onClose={onCloseApplyModal}
                templateId={id}
                templateName={template.name}
            />

            <div className="ulysses-sequences-title">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="bold">Template Details: {template.name}</h5>
                    <Button
                        variant="primary"
                        onClick={onApplyTemplateClick}
                        className="btn-sm"
                    >
                        <i className="fas fa-share me-2"></i>
                        Apply to Campaigns
                    </Button>
                </div>
            </div>

            <div className="container">
                <div className="sequence-detail-container">
                    {renderSteps()}
                </div>
            </div>
        </div>
    );
}

export default TemplateDetail;
